import $ from 'jquery';
import Vue from 'vue';
import FileSelectComponent from './file-select';

const FileSelect = Vue.extend(FileSelectComponent);

$('input[type="file"]')
    .each(function () {
        const vm = new FileSelect({
            propsData: {
                input: this,
            }
        });
        vm.$mount();
        $(this).after(vm.$el);
    });
